<template>
  <b-form-group
    label="Oran"
    label-for="rate"
  >
    <validation-provider
      #default="{ errors }"
      name="Oran"
      rules="required"
    >
      <b-form-input
        id="rate"
        v-model="dataItem.rate"
        placeholder="Oran"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Rate',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['taxes/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>

<style scoped>

</style>
